module.exports = __webpack_public_path__ + "img/orar.dc32e2fc.png";